<template>
<div ref="todownload">Downloanding.....</div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'Accessi',
  components: {
  },
  data () {
    return {
      loading: true,    
      href: '#!',
      download: '',     
      file: {nome:'', url:''}
    }
  },
  created () {
    console.log(" Arrivo al download.vue con file  "+this.$route.params.file);
    this.fetchData()
  },
  watch: {
    // call again the method if the route changes
    '$route': 'fetchData'
  },
  methods: {
    fetchData () {
        this.loading = this.$loading({lock: true, text: 'Download in corso, non ricaricare la pagina.....', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' })
        this.file =  JSON.parse(this.$aes.decode(this.$route.params.file))



        axios({
        url: this.file.url,
        method: 'GET',
        responseType: 'blob', // important
        }).then((response) => {
          console.log(response)
          if(response.data.type!='text/html'){
            const url = window.URL.createObjectURL(new Blob([response.data]))
            
            const link = document.createElement('a');
            link.href = url
            link.setAttribute('download', this.file.name);
            this.$refs.todownload.appendChild(link);
            link.click()
          
            this.loading.close()
            this.$router.go(-1)
          }else{
            throw new Error('Whoops!')
          }
        }).catch(error=>{
          this.loading.close()
          this.$alert('File not found!', 'An error occurred', {
            confirmButtonText: 'OK',
            type: 'warning'
          }).then( () => {
            this.$router.go(-1)
          }).catch(() => {
            this.$router.go(-1)
          })
          
        })

        
    }
  }
}
</script>
